import { render } from "./ClientParentTemp.vue?vue&type=template&id=1fd53a24&scoped=true"
import script from "./ClientParentTemp.vue?vue&type=script&lang=js"
export * from "./ClientParentTemp.vue?vue&type=script&lang=js"

import "./ClientParentTemp.vue?vue&type=style&index=0&id=1fd53a24&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd53a24"]])

export default __exports__